export default __webpack_public_path__ + "static/722-72cc3a0f80d03c0d59a47031b4b34251.gif";